import {Component, Input} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {NgClass} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-password-input',
  imports: [
    NgClass,
    ReactiveFormsModule,
    TranslatePipe
  ],
  templateUrl: './password-input.component.html',
  styleUrl: './password-input.component.css'
})
export class PasswordInputComponent {
  @Input() parentForm!: FormGroup; // Receive the login form from parent as input
  @Input() controlName: string;
  @Input() inputId: string;
  @Input() label: string;
  @Input() required: boolean = false;

  fieldTextType: boolean = false;
  hasFocus: boolean = false;

  getFormControl() {
    return this.parentForm.get(this.controlName);
  }

  onFocus(): void {
    this.hasFocus = true;
  }

  onBlur(): void {
    this.hasFocus = false;
  }

  onTogglePasswordMouseDown(ev: MouseEvent) {
    ev.preventDefault();
    this.toggleFieldTextType();
  }

  toggleFieldTextType(): void {
    this.fieldTextType = !this.fieldTextType;
    const el = document.getElementById(this.inputId) as HTMLInputElement;
    el?.focus();
    this.hasFocus = true;
  }
}
